import React, { Component } from "react";
import MyForm from "./MyForm";
import Categories from "./Categories";
import Category from "./Category";
import Message from "./Message";

class Body extends Component {
  constructor(props) {
    super(props);

    this.paramsUrl = new URLSearchParams(window.location.search);
    this.state = {
      show: false,
      data: null,
      activeCategory: null,
      message: this.paramsUrl.get("message") || null,
      error: this.paramsUrl.get("error") || null
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    fetch("https://support.kama.gs/dv/appeal" + window.location.search)
      .then(data => data.json())
      .then(data => {
        this.setState({ show: true, data });
      })
      .catch(() => {
        this.setState({ show: true });
      });
  }

  setActiveCategory(activeCategory) {
    this.setState({ activeCategory });
  }

  handleBack = () => {
    this.paramsUrl.delete("message");
    this.paramsUrl.delete("error");

    const paramsUrl = this.paramsUrl.toString();
    const query = paramsUrl ? "?" + paramsUrl : "";

    window.history.pushState(
      null,
      null,
      window.location.origin + window.location.pathname + query
    );
    this.setState({ message: null, error: null });
  };

  render() {
    const { show, data, activeCategory, message, error } = this.state;

    if (!show) {
      return null;
    }

    if (message || error) {
      return (
        <Message
          message={message || error}
          src={message ? "panda" : "bear"}
          onClick={this.handleBack}
        />
      );
    }

    if (this.paramsUrl.get("locale") !== 'ru' || this.paramsUrl.get("locale") !== 'kk') {
      return (
        <div className="container-fluid">
          <MyForm allow_message allow_screenshot en/>
        </div>
      );
    }

    if (!this.paramsUrl.get("labels") || !data.length) {
      return (
        <div className="container-fluid">
          <MyForm allow_message allow_screenshot />
        </div>
      );
    }

    if (data) {
      if (!activeCategory) {
        return (
          <Categories
            categories={data}
            setActiveCategory={this.setActiveCategory.bind(this)}
          />
        );
      }

      if (activeCategory) {
        return (
          <Category
            category={activeCategory}
            setActiveCategory={this.setActiveCategory.bind(this)}
          />
        );
      }
    }
  }
}

export default Body;



// WEBPACK FOOTER //
// ./src/Body.js